import React from 'react';

const MenuContext = React.createContext({});
const MenuParentContext = React.createContext({});

export { MenuParentContext };
export default MenuContext;
